export const features = [
  // ========================= //
  // ALWAYS-ON MONITORING
  // ========================= //
  {
    icon: 'eye',
    name: 'Always-On Monitoring',
    summary: `Get a robot that continuously watches your fleet telemetry for specific behaviour.`,
    title: 'Automate Risk Management and Save Time and Money with Continuous Monitoring',
    lead: `Radar continuously watches your fleet's telemetry data. You can setup automation rules to tell it what to watch out for. When it sees a rule is triggered, it can trigger a workflow or notification, and logs it for future reference.`,
    image: '/images/features/automation-logs.png',
    sections: [
      {
        heading: 'Flexible Configuration, Unlimited Rules',
        body: 'Configure Radar to watch for only specific events with detailed options, and watch for as many events as you need (Fair Usage Policy applies).'
      },
      {
        heading: 'Isolate Inside Geofences',
        body: 'Only watch for events inside or outside specific geofences, or trigger rules when vehicles enter or exit specific areas.'
      },
      {
        heading: 'Run It On A Schedule',
        body: 'You can tell Radar to only trigger rules during specific times. For example, watch for events happening overnight, or keep tabs on things during weekends.'
      }
    ]
  },

  // ========================= //
  // REALTIME ALERTS & NOTIFICATIONS
  // ========================= //
  {
    icon: 'bell-on',
    name: 'Realtime Alerts & Notifications',
    summary: `Send messages via phone to email to the right people at the right time.`,
    title: 'Push Information to the Right Person at the Right Time',
    lead: 'When a rule is triggered you can send an SMS, email, or push notification to a contact who needs to be made aware of it.',
    image: '/images/features/realtime-alerts.png',
    sections: [
      {
        heading: 'Unlimited Contacts',
        body: 'Setup as many contacts to be notified of events as you like.'
      },
      {
        heading: 'Notify Contacts via Phone or Email',
        body: `Send SMS or emails to any of your contacts when rules are triggered.`
      },
      {
        heading: 'Message Drivers Directly',
        body: `Send a message directly to the driver's in-vehicle device to be read aloud.`
      }
    ]
  },

  // ========================= //
  // AUTOMATED WORKFLOWS
  // ========================= //
  {
    icon: 'sync',
    name: 'Automated Workflows',
    summary: `Trigger prompts, reminders and warnings to help streamline daily operations.`,
    title: `Get Your Fleet Operation Running Like Clockwork`,
    lead: 'Drivers are the linchpin of your organisation. Invest in improving their health and behaviour and promote responsibility with automated prompts and workflows.',
    image: '/images/features/automated-workflows.png',
    sections: [
      {
        heading: 'Remind Drivers to Login & Start Work',
        body: `Improve the quality of your driver data and make sure drivers stay accountable by reminding them login and start work.`,
      },
      {
        heading: 'Manage Fatigue & Rest Periods',
        body: `Promote driver health and safety with automatic prompts to the driver to pull over and rest for a specified period of time.`,
      },
      {
        heading: 'Actively Send Disciplinary Messages',
        body: `Bring down your expenses on fuel, fines, and compliance. Whenever unwanted driving behaviour is detected, send the driver a custom warning or reminder.`
      },
    ]
  },
  
  // ========================= //
  // MONITOR DASHBOARD
  // ========================= //
  {
    icon: 'broadcast-tower',
    name: 'Monitor Dashboard',
    summary: `Keep a human eye on things in your control room with a centralised dashboard.`,
    title: 'Keep An Eye On Things From Your Monitor Dashboard',
    lead: 'Get your own interactive vehicle map inside of Fleetbeacon with a notification feed where you can push alerts from triggered automation rules.',
    image: '/images/features/control-tower.png',
    sections: [
      {
        heading: 'Push Notifications',
        body: 'Send triggered automations into the notification feed on the monitor dashboard and easily jump to the related vehicle on the map.'
      },
      {
        heading: 'Require Acknowledgement',
        body: 'Ensure notifications are acknowledged on time and allow your controllers to add notes to notifications.'
      }
    ]
  }
]